import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

// When isDisabled truthy, set active editor in ReadOnly mode preventing changes
export default function ReadOnlyPlugin({ isDisabled }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(!isDisabled);
  }, [editor, isDisabled]);

  return null;
}
